import React, { useState } from 'react';
import SearchBar from '../explore/searchBar/searchBar';
import {useTranslation} from "react-i18next";

function filterSearch(contacts, search) {
  if(search === "") return contacts;

  const s = search.toUpperCase();

  return contacts.filter(c => {
    return c.name.toUpperCase().replace('É','E').includes(s)
  });
}

function settings_is_focused(id, focus) {
  return (focus[id] || {}).focus_enabled;
}

function settings_is_notification(id, focus) {
  return (focus[id] || {}).notification_enabled;
}

function EntityFocus({ entities, focus, notify, mode }) {
  const { t } = useTranslation();
  const [entities_s, updateEntities] = useState(() => {
    if (mode === "show") {
      return entities.filter(x =>
	settings_is_focused(x.id, focus)
	|| settings_is_notification(x.id, focus)
      );
    }
    return entities;
  })
  const [search, setSearch] = React.useState("");
  const [active_display, setActiveDisplay] = React.useState(false);

  const starValue = (c) => c.new_star !== undefined ? c.new_star : settings_is_focused(c.id, focus);
  const notificationValue = (c) => c.new_notification !== undefined ? c.new_notification : settings_is_notification(c.id, focus);

  function flag(id, cb) {
    if (mode === "show") return;

    const new_entities = entities_s.map(x => {
      return x.id === id ? cb(x) : x;
    });

    notify(new_entities);
    updateEntities(new_entities);
  }

  function setFocusStar(id) {
    return flag(id, (x) => {
      return {...x, new_star: !starValue(x)};
    })
  }

  function setNotification(id) {
    return flag(id, (x) => {
      return {...x, new_notification: !notificationValue(x)};
    })
  }

  // mass toggling only work for focus and not notification
  function toggleDisplay(){
    if (mode === "show") return;
    setActiveDisplay(!active_display);
  }



  let filtered_entities = entities_s;

  if (active_display) {
    filtered_entities = entities_s.filter(e =>
      settings_is_focused(e.id, focus)
      || settings_is_notification(e.id, focus)
      || e.new_notification
      || e.new_star
    )
  }

  filtered_entities = filterSearch(filtered_entities, search);

  let view;

  if(mode === "edit"){
    view = <>
    <div className="c-showedit_selectAll">
      <input type="checkbox" style={{cursor: "pointer", marginRight: "5px", height: "18px"}} onClick={toggleDisplay} />
      { t("Show active elements only") }
    </div>
    </>
  }

  return (
    <>
      <div className="c-container_search-bar">
        <SearchBar value={search} handleChange={e => setSearch(e.target.value)} />
      </div>
      {view}
      <div className={`c-container_infos main-data container-focus-mode-${mode}`}>
        <div className="focus-entity-list">
          {filtered_entities.map(e => {
            return <div key={e.id} className="focus-entity">
              <div className="focus-contact-img-wrapper">
                <img src={e.img} alt="profile" />
                <div className={"focus-star" + (starValue(e) ? " active" : "")}
                     onClick={() => setFocusStar(e.id)} />
                <div className={"notify-icon" + (notificationValue(e) ? " active" : "")}
                     onClick={() => setNotification(e.id)} />
              </div>
              <div className="focus-entity-fullname">{e.name}</div>
            </div>
          }) }
        </div>
      </div>
    </>

  )
}


export default EntityFocus;
